import { useEffect } from "react";
import { useContent } from "../../lib/content";
import { mediaUrl } from "../../lib/api";

const setMeta = (sel, attr, val) => {
  if (!val) return;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    const [k, v] = sel.replace(/^meta\[|\]$/g, "").split("=");
    el.setAttribute(k, v.replace(/"/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, val);
};

export function useSeo(pageTitle, pageDesc) {
  const { seo } = useContent();
  useEffect(() => {
    const title = pageTitle ? `${pageTitle} · TERMONLINE` : seo?.title;
    const desc = pageDesc || seo?.description;
    if (title) document.title = title;
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", desc);
    if (seo?.og_image) setMeta('meta[property="og:image"]', "content", new URL(mediaUrl(seo.og_image), window.location.origin).href);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = window.location.origin + window.location.pathname;
  }, [seo, pageTitle, pageDesc]);
}
